import type { TransferFilter, JobFilter } from '@/types';

export const QK = {
  // Auth
  ME: ['me'] as const,

  // Transfers
  TRANSFERS_LIST: (f: TransferFilter) => ['transfers', 'list', f] as const,
  GUEST_TRANSFERS_LIST: (f: TransferFilter) => ['transfers', 'guest', f] as const,
  TRANSFER: (id: string) => ['transfers', id] as const,
  TRANSFER_OFFERS: ['transfers', 'offers'] as const,
  TRANSFERS_MINE: ['transfers', 'mine'] as const,

  // Transfer Requests
  TRANSFER_REQUESTS_LIST: (f: any) => ['transfer-requests', 'list', f] as const,
  TRANSFER_REQUEST: (id: string) => ['transfer-requests', id] as const,

  // Jobs
  GUEST_JOBS_LIST: (f: JobFilter) => ['jobs', 'guest', f] as const,
  JOBS_LIST: (f: JobFilter) => ['jobs', 'list', f] as const,
  JOB: (id: string) => ['jobs', id] as const,
  JOB_APPS: (id: string) => ['jobs', id, 'applications'] as const,
  JOBS_MINE: ['jobs', 'mine'] as const,
  MY_APPLICATIONS: ['jobs', 'applications', 'mine'] as const,

  // FRANCHISE
  FRANCHISE_LIST: (f: object) => ['franchises', 'list', f],
  GUEST_FRANCHISE_LIST: (f: object) => ['franchises', 'guest', f],
  FRANCHISE: (id: string) => ['franchises', id],

  // candidates
  CANDIDATE_LIST: ['candidate-profiles', 'list'] as const,
  GUEST_CANDIDATE_LIST: (f?: object) => ['candidate-profiles', 'guest', f] as const,
  CANDIDATE_MINE: ['candidate-profiles', 'mine'] as const,
  CANDIDATE_DETAIL: (id: string) => ['candidate-profiles', id] as const,
  // Companies
  COMPANIES_LIST: (f: object) => ['companies', 'list', f] as const,
  COMPANY: (id: string) => ['companies', id] as const,
  // CHAT
  CONVERSATIONS: ['chat', 'conversations'] as const,
  MESSAGES: (id: string) => ['chat', 'messages', id] as const,
  // Notifications
  NOTIFICATIONS: ['notifications', 'mine'] as const,

} as const;
